import { Chip } from '@pets-ui/Chip/Chip'
import { HStack } from '@pets-ui/HStack/HStack'
import { type ReactNode } from 'react'

export interface Category<Value> {
  value: Value
  label: ReactNode
}

export interface CouponCategoriesProps<Value> {
  categories?: Category<Value>[]
  onChange?: (value: Value) => void
  value?: Value
}

export const CouponCategories = <Value extends string>(props: CouponCategoriesProps<Value>) => {
  const { categories, onChange, value } = props

  const handleChange = (category: Category<Value>) => () => {
    onChange?.(category.value)
  }

  return (
    <HStack p={4} gap={3} flexWrap="nowrap" overflowX="auto" flexShrink={0}>
      {categories?.map(category => (
        <Chip
          key={category.value}
          onClick={handleChange(category)}
          selected={category.value === value}
        >
          {category.label}
        </Chip>
      ))}
    </HStack>
  )
}
